<div class="container">
  <h1 class="mt120">Welcome to the iTIM Leader’s Training Seminar.</h1>
</div>

<div class="mainContnet">
  <div class="container">
    <p>
      The free iTIM seminar will enable you to use iTIM to equip God’s people
      for works of ministry, and get them involved in ministry.
    </p>
    <p>
      The Seminar covers the content of the Operations manual in 10, five to six
      minute videos, each followed with a quiz. You can take just part of it at
      a time, save your work and complete it later. It can be completed in about
      2 hours. Your completion of the seminar will also allow you to download it
      free to share with your congregation.
    </p>
    <p>
      Completing the Seminar is required in order to purchase iTIM courses
      either as hard copies, or online.
    </p>
    <p>
      <a
        style="cursor: pointer; text-decoration: underline"
        (click)="handleRedirect()"
        >Start the Seminar</a
      >
    </p>
  </div>
  <app-static-footer></app-static-footer>
</div>
